// extracted by mini-css-extract-plugin
export default {"desc":"index_desc_J8Kl3","wrap":"index_wrap_LXPnh","like":"index_like_WWhWi","comment":"index_comment_24-Y4","share":"index_share_W0NYl"};